export default "__VITE_ASSET__DkEYcr7V__"